import { getDoc, doc } from 'firebase/firestore';

import { firestore } from '../index';
import { transformMerchant } from './transformers/merchant';

import { Collections } from '../../types/collections';
import { Merchant } from '../../types/merchant';

export const getMerchant = async (storeID: string): Promise<Merchant | null> => {
  const querySnapshot = await getDoc(doc(firestore, Collections.Merchants, storeID));

  if (!querySnapshot.exists) {
    return null;
  }

  return transformMerchant(querySnapshot);
};
